import * as React from 'react';
import './ScrollPanel.css';

interface ScrollPanelProps {
    className?: string
    height?: string | number
    children?: React.ReactNode
}

export default class ScrollPanel extends React.Component<ScrollPanelProps> {
    render() {
        const { className, height, children } = this.props;
        return (
            <div
                className={`scroll-panel ${className ?? ''}`}
                style={{ overflowY: 'auto', height: height ?? '200px' }}
            >
                {children}
            </div>
        );
    }
}